import React, { useState, useEffect } from "react";
import {
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

// 🔢 Génère un ID unique de commande
function generateOrderId() {
  const timestamp = new Date()
    .toISOString()
    .replace(/[-:.TZ]/g, "")
    .slice(0, 14);
  const randomPart = Math.floor(100 + Math.random() * 900);
  return `CMD-${timestamp}-${randomPart}`;
}

const CheckoutForm = ({ montant, livraison }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [hasPaidShipping, setHasPaidShipping] = useState(false);

  const montantTotal = montant
    ? parseFloat(montant) + (hasPaidShipping ? 0 : 6)
    : hasPaidShipping
    ? 0
    : 6;

  useEffect(() => {
    const paidShipping = localStorage.getItem("hasPaidShipping");
    const timestamp = localStorage.getItem("shippingTimestamp");

    if (paidShipping === "true" && timestamp) {
      const now = Date.now();
      const elapsed = now - parseInt(timestamp, 10);
      const oneDay = 6 * 60 * 60 * 1000; // 24 heures en ms

      if (elapsed < oneDay) {
        setHasPaidShipping(true);
      } else {
        // Expiré → on nettoie
        localStorage.removeItem("hasPaidShipping");
        localStorage.removeItem("shippingTimestamp");
      }
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    if (!stripe || !elements) {
      setError("Stripe n’est pas prêt.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        "https://b-zpro-api-2.vercel.app/api/create-payment-intent",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ amount: Math.round(montantTotal * 100) }),
        }
      );

      const { clientSecret } = await response.json();

      const result = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
        },
      });

      if (result.error) {
        setError(result.error.message);
      } else if (result.paymentIntent.status === "succeeded") {
        const commandeId = generateOrderId();

        // Envoi de l'email avec toutes les infos de livraison
        await fetch("https://b-zpro-api-2.vercel.app/api/send-email", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id : commandeId,
            reference: livraison.reference,
            nom: livraison.nom,
            prenom: livraison.prenom,
            email: livraison.email,
            telephone: livraison.telephone,
            adresse: livraison.adresse,
            pays: livraison.pays,
            zipCode: livraison.zipCode,
            ville: livraison.ville,
            montant: montantTotal.toFixed(2),
            selectedPointRelais: livraison.selectedPointRelais,
          }),
        });

        // Sauvegarde de la commande dans le localStorage
        // IMPORTANT : on ajoute selectedPointRelais dans l'objet de commande
        const commande = {
          id: commandeId,
          date: new Date().toLocaleDateString(),
          montant: montantTotal,
          etat: "En attente2",
          transporteur: "Mondial Relay",
        };

        const commandes = JSON.parse(localStorage.getItem("commandes")) || [];
        commandes.push(commande);
        localStorage.setItem("commandes", JSON.stringify(commandes));

        setSuccess(true);
        localStorage.setItem("hasPaidShipping", "true");
        localStorage.setItem("shippingTimestamp", Date.now().toString());
        window.location.href = "/confirmation";
      }
    } catch (err) {
      setError("Erreur lors du paiement : " + err.message);
    }

    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="checkout-form">
      {hasPaidShipping && (
        <p className="info-message" style={{ color: "#2b3a4a", fontWeight: "bold" }}>
          🚚 Les frais de port ont déjà été réglés. Ils ne seront pas facturés cette fois-ci.
        </p>
      )}

      <div className="card-input-container">
        <CardElement className="card-input" />
      </div>

      {error && <p className="error-message">❌ {error}</p>}
      {success && <p className="success-message">✅ Paiement validé !</p>}
      <br />
      <button type="submit" disabled={!stripe || loading} className="stripe-pay-btn">
        {loading ? "Paiement en cours..." : `💳 Payer ${montantTotal} €`}
      </button>
    </form>
  );
};

export default CheckoutForm;
